import React, { useEffect, useState } from "react";
import { Row, Col, Typography } from "antd";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import HeaderIndex from "apps/layout/Header/HeaderIndex";
import FooterIndex from "apps/layout/Footer/FooterIndex";
import { useGetPageDetailsByPageType } from "apps/FAQ/ServerSideStates";
import StaticPageBanner from "apps/Common/StaticPageBanner";
import TruncatedText from "apps/Common/TruncatedText";
import { Helmet } from "react-helmet-async";

const ManagementTeam = () => {
  const { Text } = Typography;
  const pageDetails = useGetPageDetailsByPageType(3);
  const [groupDataList, setGroupDataList] = useState([]);

  useEffect(() => {
    if (pageDetails?.data?.data?.pageItem) {
      const data = pageDetails?.data?.data?.pageItem;

      const titles = data.filter((item: any) => item.isTitle === true);

      const groupedData = titles.map((title: any) => ({
        name: title.name, // Ana başlık
        subTopics: data.filter(
          (item: any) =>
            item.isTitle === false && item.groupId === title.groupId
        ),
      }));

      setGroupDataList(groupedData);
    }
  }, [pageDetails?.data?.data]);

  return (
    <>
      <Col xs={24}>
        <Row gutter={[20, 40]}>
          <Col xs={24}>
            <StaticPageBanner
              title={pageDetails?.data?.data?.name || ""}
              description={pageDetails?.data?.data?.shortDescription || ""}
            />
            <Helmet>
              <title className="capitalize">{"Ekibimiz"}</title>
            </Helmet>
          </Col>
          <Col xs={24}>
            <Row
              gutter={[
                { xs: 10, sm: 20, md: 25, lg: 30, xl: 35, xxl: 40 },
                { xs: 10, sm: 20, md: 25, lg: 30, xl: 35, xxl: 40 },
              ]}
              className="!px-2 lg:!px-6 xxl:!px-16"
            >
              {groupDataList.map((item: any, index) => {
                console.log("item", item);
                return (
                  <>
                    <Col xs={12} lg={12} xl={6} key={index}>
                      <div
                        className="group !p-2 sm:!p-4 md!p-8 !bg-gray-200 !flex flex-col gap-3 !relative"
                        id="main"
                      >
                        <div className="!flex justify-center">
                          <LazyLoadImage
                            classNames="!w-[100px] !h-[100px] md:!w-[200px] md:!h-[200px]"
                            wrapperHeight="200px"
                            wrapperWidth="200px"
                            src={item?.icon?.fullPath}
                            alt=""
                          />
                        </div>
                        <TruncatedText
                          wrapperClassName="!flex justify-center"
                          textClassName="!text-base md:!text-2xl !text-[#0046be] !font-bold"
                          title={item.name}
                          maxLines={1}
                        />

                        <div>
                          {item.subTopics.map((subItem: any, index: number) => {
                            return (
                              <>
                                <TruncatedText
                                  wrapperClassName="!flex justify-center"
                                  textClassName="!text-black"
                                  title={subItem.name}
                                  maxLines={1}
                                />
                              </>
                            );
                          })}
                        </div>
                      </div>
                    </Col>
                  </>
                );
              })}
            </Row>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default ManagementTeam;